export default {
  // Basic info
  'agents.title': 'Agents',
  'agents.tab.ai': 'AI',
  'agents.tab.rpa': 'RPA',

  // AI Provider options (for filters and forms)
  'agents.ai.provider.openai': 'OpenAI',

  // RPA Platform options (for filters and forms)
  'agents.rpa.platform.windows': 'Windows',
  'agents.rpa.platform.android': 'Android',

  // RPA Status options (for filters and forms)
  'agents.rpa.status.unknown': 'Unknown',
  'agents.rpa.status.online': 'Online',
  'agents.rpa.status.offline': 'Offline',
  'agents.rpa.status.disabled': 'Disabled',

  // Buttons
  'agents.button.interact': 'Interact',

  'agents.text.ownerUser': 'Owner',

  // Form field translations
  'agents.form.provider': 'Provider',
  'agents.form.publisher': 'Publisher',
  'agents.form.model': 'Model',
  'agents.form.connections': 'Connections',
  'agents.form.connections.connection': 'Connection',
  'agents.form.allowedRoles': 'Role Configuration',
  'agents.form.allowedRoles.allowed': 'Allowed Roles',
  'agents.form.allowedRoles.denied': 'Denied Roles',
  'agents.form.memory': 'Memory',
  'agents.form.platform': 'Platform',
  'agents.form.name': 'Name',
  'agents.form.email': 'Email',
  'agents.form.username': 'Username',
  'agents.form.domains': 'Domains',
  'agents.form.description': 'Description',
  'agents.form.longDescription': 'Long Description',
  'agents.form.instructions': 'Instructions',
  'agents.form.instructions.edit': 'Edit Instructions',
  'agents.form.instructions.placeholder.expanded':
    'Write detailed instructions for your AI agent...',
  'agents.form.icon': 'Icon',
  'agents.form.isActive': 'Active',
  'agents.form.status': 'Status',
  'agents.form.deviceName': 'Device Name',
  'agents.form.ip': 'IP Address',
  'agents.form.ip.error': 'Please enter a valid IP address',

  // Configuration translations
  'agents.form.configurations.greetings': 'Greetings',
  'agents.form.configurations.greetings.message': 'Message',
  'agents.form.configurations.greetings.message.edit': 'Edit Greeting Message',
  'agents.form.configurations.greetings.message.placeholder':
    'Write the greeting message for this language...',
  'agents.form.configurations.searchingHumanAgentMessages': 'Searching Human Agent Messages',
  'agents.form.configurations.searchingHumanAgentMessages.message': 'Message',
  'agents.form.configurations.searchingHumanAgentMessages.message.edit': 'Edit Search Message',
  'agents.form.configurations.searchingHumanAgentMessages.message.placeholder':
    'Write the human agent search message for this language...',
  'agents.form.configurations.trainingVectors': 'Training Vectors',
  'agents.form.configurations.reasoningEffort': 'Reasoning Effort',
  'agents.form.configurations.reasoningEffort.minimal': 'Minimal',
  'agents.form.configurations.reasoningEffort.low': 'Low',
  'agents.form.configurations.reasoningEffort.medium': 'Medium',
  'agents.form.configurations.reasoningEffort.highcompleted': 'High',
  'agents.form.configurations.reasoningSummary': 'Reasoning Summary',
  'agents.form.configurations.reasoningSummary.concise': 'Concise',
  'agents.form.configurations.reasoningSummary.detailed': 'Detailed',
  'agents.form.configurations.reasoningSummary.auto': 'Auto',
  'agents.form.configurations.allowedTools': 'Allowed Tools',
  'agents.form.configurations.allowedTools.codeinterpreter': 'Code Interpreter',
  'agents.form.configurations.allowedTools.filesearch': 'File Search',
  'agents.form.configurations.allowedTools.websearch': 'Web Search',
  'agents.form.configurations.allowedTools.imagegeneration': 'Image Generation',
  'agents.form.configurations.allowedTools.mcp': 'MCP',
  'agents.form.configurations.guardrails.title': 'Guardrails',
  'agents.form.configurations.guardrails.moderation.enabled': 'Moderation Options Enabled',
  'agents.form.configurations.guardrails.pii.enabled': 'PII Options Enabled',
  'agents.form.configurations.guardrails.pii.rules': 'PII Rules',
  'agents.form.configurations.guardrails.pii.rules.entity': 'Entity',
  'agents.form.configurations.guardrails.pii.rules.entity.creditcard': 'Credit Card',
  'agents.form.configurations.guardrails.pii.rules.entity.email': 'Email',
  'agents.form.configurations.guardrails.pii.rules.entity.phone': 'Phone',
  'agents.form.configurations.guardrails.pii.rules.entity.ipaddress': 'IP Address',
  'agents.form.configurations.guardrails.pii.rules.entity.ibancode': 'IBAN Code',
  'agents.form.configurations.guardrails.pii.rules.entity.url': 'URL',
  'agents.form.configurations.guardrails.pii.rules.entity.usbanknumber': 'US Bank Number',
  'agents.form.configurations.guardrails.pii.rules.entity.usitin': 'US ITIN',
  'agents.form.configurations.guardrails.pii.rules.entity.uspassport': 'US Passport',
  'agents.form.configurations.guardrails.pii.rules.entity.usssn': 'US SSN',
  'agents.form.configurations.guardrails.pii.rules.entity.pedni': 'PE DNI',
  'agents.form.configurations.guardrails.pii.rules.entity.peruc': 'PE RUC',
  'agents.form.configurations.guardrails.pii.rules.entity.pepassport': 'PE Passport',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountnumber':
    'PE Bank Account Number',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountcci': 'PE Bank Account CCI',
  'agents.form.configurations.guardrails.pii.rules.action': 'Action',
  'agents.form.configurations.guardrails.pii.rules.action.mask': 'Mask',
  'agents.form.configurations.guardrails.pii.rules.action.pseudonymize': 'Pseudonymize',
  'agents.form.configurations.guardrails.pii.rules.action.tokenizereversible':
    'Tokenize Reversible',
  'agents.form.configurations.guardrails.pii.rules.action.remove': 'Remove',
  'agents.form.configurations.guardrails.pii.rules.action.keep': 'Keep',
  'agents.form.configurations.guardrails.pii.rules.maskChar': 'Mask Character',
  'agents.form.configurations.guardrails.pii.rules.keepPrefix': 'Keep Prefix',
  'agents.form.configurations.guardrails.pii.rules.keepSuffix': 'Keep Suffix',
  'agents.form.configurations.guardrails.urlFilter.enabled': 'URL Filter Options Enabled',
  'agents.form.configurations.guardrails.urlFilter.action': 'Action',
  'agents.form.configurations.guardrails.urlFilter.action.block': 'Block',
  'agents.form.configurations.guardrails.urlFilter.action.mask': 'Mask',
  'agents.form.configurations.guardrails.urlFilter.action.warn': 'Warn',
  'agents.form.configurations.guardrails.urlFilter.mode': 'Mode',
  'agents.form.configurations.guardrails.urlFilter.mode.allowlist': 'Allow List',
  'agents.form.configurations.guardrails.urlFilter.mode.denylist': 'Deny List',
  'agents.form.configurations.guardrails.urlFilter.allowedDomains': 'Allowed Domains',
  'agents.form.configurations.guardrails.urlFilter.blockedDomains': 'Blocked Domains',
  'agents.form.configurations.guardrails.urlFilter.blockedRegex': 'Blocked Patterns (Regex)',
  'agents.form.configurations.guardrails.urlFilter.domain': 'Domain',
  'agents.form.configurations.guardrails.urlFilter.pattern': 'Pattern',
  'agents.form.configurations.guardrails.urlFilter.allowIpHosts': 'Allow IP Hosts',
  'agents.form.configurations.guardrails.urlFilter.allowedSchemes': 'Allowed Schemes',
  'agents.form.configurations.guardrails.urlFilter.scheme': 'Scheme',
  'agents.form.configurations.guardrails.urlFilter.maxUrls': 'Max URLs',
  'agents.form.configurations.guardrails.urlFilter.blockUrlShorteners': 'Block URL Shorteners',
  'agents.form.configurations.guardrails.urlFilter.urlShortenerDomains': 'URL Shortener Domains',
  'agents.form.configurations.guardrails.jailbreak.enabled': 'Jailbreak Options Enabled',
  'agents.form.configurations.guardrails.jailbreak.model': 'Model',
  'agents.form.configurations.guardrails.jailbreak.blockConfidence': 'Block Confidence',

  // Tabs
  'agents.tabs.general': 'General',
  'agents.tabs.configurations': 'Configurations',

  // Wizard steps
  'agents.wizard.steps.basicInformation': 'Basic Information',
  'agents.wizard.steps.technicalConfiguration': 'Technical Configuration',
  'agents.wizard.steps.permissionsAndContent': 'Permissions and Content',
  'agents.wizard.steps.advancedConfigurationAndContent': 'Advanced Configuration and Content',
  'agents.wizard.steps.guardrails': 'Guardrails',

  // Global translations
  'global.text.configuration': 'Configuration',
};
